// extracted by mini-css-extract-plugin
export default {"NavigationItems":"NavigationItems_NavigationItems__O0Khc","NavigationItemIcon":"NavigationItems_NavigationItemIcon__U9MH7"};